import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Popover } from "antd";
import { withRouter } from "react-router-dom";
import { MyIcon } from "../../common/baseConfig";
import * as actions from './redux/actions';

export class SettingPane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { setFontSize } = this.props.actions;
    const content = (
      <div className="setting-font">
        <p className="max" onClick={() => {
          setFontSize({ payload: 18 })
        }}>大</p>
        <p className="mid" onClick={() => {
          setFontSize({ payload: 16 })
        }}>中</p>
        <p className="min" onClick={() => {
          setFontSize({ payload: 14 })
        }}>小</p>
      </div>
    )
    return (
      <div className="ques-store-setting-pane">
        <div className="back" onClick={() => {
          this.props.history.goBack();
        }}>
          <p className="icon">
            <MyIcon type="iconfanhui" />
          </p>
          <p className="txt">返回</p>
        </div>
        <div className="setting">
          <Popover placement="bottomRight" title={"字体设置"} content={content} trigger="click">
            <p className="icon">
              <MyIcon type="iconshezhi" />
            </p>
          </Popover>
          <p className="txt">设置</p>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SettingPane));



// WEBPACK FOOTER //
// ./src/features/ques-store/SettingPane.js